import { Navigate } from "react-router";
import { useGetBuyerQuery } from "../../../apis/Buyer.api";
import { PrimaryBuyer, Buyer } from "../../../types/models/Buyer";
import GradientCircularProgress from "../../../../share/components/progress/GradientCircularProgress";

export const BuyerScoped = () => {
    const {
        data,
    } = useGetBuyerQuery(PrimaryBuyer.fromPath('scoped'))

    if (data) {
        const url = `/dashboard/buyers/${data.id}?scoped=true`
        return <Navigate to={url} replace/>
    } else {
        return <>
            <GradientCircularProgress/>
        </>
    }
}
export default BuyerScoped;
